import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {unsafeSVG} from "lit/directives/unsafe-svg.js";
import Styles from "./inlineModalDialogIndicator.lit.scss";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";
import {PLUS_ICON} from "../../../common/svgIcons";

const PLUS_SIGN_WITH_CLASS = PLUS_ICON.replace("<svg", "<svg class='indicator-plus'");

@customElement("eop-inline-modal-dialog-indicator")
export class EopInlineModalDialogIndicator extends DialogAnchorTemplateContent {

    public static readonly styles = Styles;

    @property({attribute: "title"})
    public buttonTitle: string;

    public render(): TemplateResult {
        return html`
            <button @click=${this.openDialog}
                    @keydown=${this.openDialog}
                    type=button
                    class="indicator-link"
                    title=${this.buttonTitle}
            >
                    ${unsafeSVG(PLUS_SIGN_WITH_CLASS)}
            </button>`;
    }
}